// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface OtherAnnoyancesAltIconSignature {
  Element: SVGSVGElement;
}

export const OtherAnnoyancesAltIcon: TOC<OtherAnnoyancesAltIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.99998 18.9999C4.65298 18.9999 4.33198 18.8199 4.14898 18.5259C3.96598 18.2299 3.95098 17.8629 4.10498 17.5519L11.105 2.55194C11.444 1.87494 12.555 1.87494 12.894 2.55194L19.894 17.5519C20.048 17.8629 20.033 18.2289 19.85 18.5259C19.668 18.8209 19.347 18.9999 19 18.9999H13V21.9999H11V18.9999H4.99998ZM11 16.9999H13L17.382 16.9999L12 5.23694L6.61798 16.9999L11 16.9999ZM13 12.9999V8.99994H11V12.9999H13ZM13 13.9999V15.9999H11V13.9999H13Z"/>
</svg>
</template>;